<template>
  <div class="synchro-settings__view">
    <h1 class="mb-2 mt-0">{{ $t("headings.synchronizationSettings") }}</h1>
    <p class="mt-0">
      {{ $t("texts.synchronizationSettings") }}
    </p>
    <synchro-settings-form class="mt-4" />
  </div>
</template>

<script setup lang="ts">
import SynchroSettingsForm from "@manager/settings/SynchroSettingsForm.vue";
</script>

<style lang="scss">
.synchro-settings {
  &__view {
    display: flex;
    flex-direction: column;
  }
}
</style>
